import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
var _excluded = ["children"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import FontAwesome from 'react-fontawesome';
var ModalWrapper = function ModalWrapper(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Modal, _extends({
    style: {
      overlay: {
        zIndex: 5000,
        backgroundColor: 'rgba(24, 39, 56, 0.85)'
      },
      content: {
        width: '60%',
        bottom: 'auto',
        left: '50%',
        marginRight: '-50%',
        maxHeight: props.maxHeight ? props.maxHeight : '60%',
        overflow: props.overflow ? props.overflow : 'auto',
        padding: props.padding ? props.padding : '20px',
        right: 'auto',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        display: props.display ? props.display : 'inherit',
        flexDirection: props.flexDirection ? props.flexDirection : 'row'
      }
    }
  }, props, {
    ariaHideApp: false
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      top: '14px',
      right: '14px',
      opacity: 0.8,
      cursor: 'pointer'
    },
    onClick: props.onRequestClose,
    "data-testid": "modal-close-button"
  }, /*#__PURE__*/React.createElement(FontAwesome, {
    name: "times",
    size: "2x"
  })), children);
};
ModalWrapper.propTypes = {
  isOpen: PropTypes.bool,
  onRequestClose: PropTypes.func
};
ModalWrapper.defaultProps = {
  isOpen: true
};
export default ModalWrapper;